// The guest sidebar's history (guided guest flow, POC): the guest's
// conversations kept on this device for 24 hours (chat/guest-store.ts),
// newest first, each with the hours it has left. A row opens /?tamu=<id>.
import { useEffect } from "react";
import { useLocation } from "../router";
import { hoursLeft, startGuestPurge, useGuestState } from "./guest-store";
import { Glyph } from "../ui/icons";

export function GuestHistory() {
  const { conversations } = useGuestState();
  const open = useLocation().query.get("tamu");
  useEffect(() => startGuestPurge(), []);
  const rows = [...conversations].sort((a, b) => b.updatedAt - a.updatedAt);
  return (
    <section className="cs-section guest-history" aria-labelledby="cs-guest-history-title">
      <div className="cs-section-head">
        <h2 id="cs-guest-history-title" className="cs-section-title">
          Riwayat (hilang setelah 24 jam)
        </h2>
      </div>
      {rows.length === 0 ? (
        <p className="cs-note">Belum ada percakapan tamu di perangkat ini.</p>
      ) : (
        <ul className="cs-rows" aria-labelledby="cs-guest-history-title">
          {rows.map((c) => {
            const left = hoursLeft(c);
            return (
              <li key={c.id} className="cs-row guest-row" data-current={c.id === open ? "" : undefined}>
                <a className="cs-row-main" href={`/?tamu=${encodeURIComponent(c.id)}`} aria-current={c.id === open ? "page" : undefined} title={c.title}>
                  <span className="cs-row-text">{c.title}</span>
                  <span className="guest-left" data-soon={left <= 2 ? "" : undefined}>
                    <Glyph name="clock" size={16} />
                    {left <= 1 ? "kurang dari 1 jam" : `${left} jam lagi`}
                  </span>
                </a>
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
}
